import {IonApp, setupIonicReact} from '@ionic/react';
import {IonReactRouter} from '@ionic/react-router';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

import 'bootstrap/dist/css/bootstrap.css';

/* Theme variables */
import 'font-awesome/css/font-awesome.min.css';

import 'maplibre-gl/dist/maplibre-gl.css';
import '../scss/app.scss';

import React from "react";
import Base from "./Base";

setupIonicReact();

const App = () =>
{
    return <IonApp>
        <IonReactRouter>
            <Base/>
        </IonReactRouter>
    </IonApp>;

};

export default App;
